import { render } from "./VoucherCode.vue?vue&type=template&id=96e27cc0&scoped=true"
import script from "./VoucherCode.vue?vue&type=script&lang=js"
export * from "./VoucherCode.vue?vue&type=script&lang=js"

import "./VoucherCode.vue?vue&type=style&index=0&id=96e27cc0&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e27cc0"]])

export default __exports__